import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";

export const ClearTestData = ({ onCleared }) => {
  const [summary, setSummary] = useState(null);
  const fetchSummary = () => api.get("/admin/test-data").then((r) => setSummary(r.data)).catch(() => {});
  useEffect(() => { fetchSummary(); }, []);

  const clear = async () => {
    try {
      const { data } = await api.delete("/admin/test-data");
      toast.success(t("Removed {loads} test loads and {bids} bids", data));
      fetchSummary(); onCleared();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const empty = summary && !summary.loads && !summary.bids;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button disabled={!summary || empty} className="hf-btn-ghost border border-red-200 text-red-600 disabled:opacity-50" data-testid="btn-clear-test-data">
          <Trash2 className="w-4 h-4" /> {empty ? t("No test data") : t("Clear test data")}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="clear-test-data-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("Clear test data?")}</AlertDialogTitle>
          <AlertDialogDescription data-testid="clear-test-data-summary">
            {t("This permanently deletes {loads} loads and {bids} bids from the demo shipper and demo transporter, with their chats and ratings. Real users' loads are not touched. The demo accounts stay.", summary || { loads: 0, bids: 0 })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="btn-cancel-clear">{t("Cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={clear} className="bg-red-600 hover:bg-red-700" data-testid="btn-confirm-clear">{t("Delete permanently")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
